// Draft <-> API mapping for an agent's optional self-driving plan (defaultPlanTemplate).
// Reuses the managed-run plan-step helpers so the same editor + serialization rules apply.
import {
  emptyStep,
  normalizeStep,
  serializeStep,
} from "../ManagedRunPolicy/planTemplateModel";

export { emptyStep };

export const createEmptySelfDrivingDraft = () => ({
  enabled: false,
  goal: "",
  tasks: [],
});

// A sensible starting point when a user first enables self-driving.
export const defaultSelfDrivingDraft = () => ({
  enabled: true,
  goal: "Work autonomously toward the goal below, checking in on a schedule until it is met.",
  tasks: [
    {
      title: "Complete the assigned objective",
      description:
        "Drive this objective to completion, waking on the schedule below to re-check progress.",
      acceptanceCriteria: ["The objective has been completed"],
      timeBound: true,
      deadline: "P7D",
      checkInterval: "P1D",
      ifMet: "Summarise the outcome and mark this task complete.",
      ifNotMet:
        "Escalate to a human (create a review task) summarising what is blocking completion.",
    },
  ],
});

// API defaultPlanTemplate -> editor draft. Absent/empty template = disabled.
export const selfDrivingDraftFromApi = (template) => {
  const tasks = Array.isArray(template?.tasks) ? template.tasks : [];
  if (!template || tasks.length === 0) {
    return createEmptySelfDrivingDraft();
  }
  return {
    enabled: true,
    goal: String(template.goal || ""),
    tasks: tasks.map(normalizeStep),
  };
};

// Editor draft -> API defaultPlanTemplate. Returns null (disabled) when off or empty.
export const selfDrivingPayloadFromDraft = (selfDriving) => {
  if (!selfDriving || !selfDriving.enabled) return null;
  const tasks = (selfDriving.tasks || [])
    .map(serializeStep)
    .filter((task) => task.title);
  if (tasks.length === 0) return null;
  return {
    goal: String(selfDriving.goal || "").trim(),
    tasks,
  };
};
